{
  "lastUpdatedAt": "2026-07-29T11:13:02.461Z",
  "lastFetchAttemptAt": "2026-07-29T11:13:02.461Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}